var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"public_affairs_app_tabbed"}},[_c('PaTabbedMenu'),_vm._v(" "),_c('PaHeadingImage'),_vm._v(" "),_c('div',{attrs:{"id":"container"}},[_c('div',{staticClass:"content"},[_c('PublicAffairsApp')],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }